import { CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/sv';
import { PwaPrompt } from 'react-ios-pwa-prompt-ts';
import AuthProvider from './contexts/authContext';
import CustomizationProvider from './contexts/customizationContext';
import ThemeProvider from './contexts/themeContext';
import { Router } from './pages/Router';

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <CustomizationProvider>
          <CssBaseline />
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="sv">
            <Router />
            <PwaPrompt />
          </LocalizationProvider>
        </CustomizationProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
